var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.structures.length > 1 ? _c('input-select', {
    attrs: {
      "name": "choice_structure",
      "value": _vm.structure,
      "datas": _vm.structures,
      "libelle": "",
      "empty-case": false,
      "value-is-object": true,
      "icon": "building",
      "always-enabled-when-neoppass-form": true
    },
    on: {
      "input": function (newValue) {
        _vm.changeStructureAndReloadInfos(newValue.id);
      }
    }
  }) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }